import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable, catchError, map, throwError } from "rxjs";
import { } from "rxjs";
import { environment } from "../../../environments/environment";

export abstract class LollyHttpService {
    constructor(public endpoint: string, public http: HttpClient) { }

    private toApiUrl(path: string) {
        let url = this.endpoint + path;
        url = url.replace("//", "/");
        console.log("API CALL TO URL = " + (environment.lollyEndpoint + url));
        console.log(environment.lollyEndpoint)
        return environment.lollyEndpoint + url;
    }
    
    public toApiUrlGlobal(path: string) {
        let url = this.endpoint + path;
        url = url.replace("//", "/");
        console.log("API CALL TO URL = " + (environment.lollyEndpoint + url));
        console.log(environment.lollyEndpoint)
        return environment.lollyEndpoint + url;
    }

    public fetchData(selectedDate: string, selectedTime: string): Observable<any> {
        const apiPath = `/data?date=${selectedDate}&time=${selectedTime}`;
        const apiUrl = this.toApiUrlGlobal(apiPath);
        return this.http.get(apiUrl, {
            responseType: "arraybuffer",
            withCredentials: true,
            headers: this.getHeaders().delete("Content-Type"),
        });
    }

    public downloadGet(api): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get(this.toApiUrl(api), {
                    responseType: "arraybuffer",
                    withCredentials: true,
                    headers: this.getHeaders().delete("Content-Type"),
                })
                .subscribe(
                    (response) => resolve(response),
                    (err) => reject(err)
                );
        });
    }

    public downloadPost(api, data): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(this.toApiUrl(api), data, {
                    responseType: "arraybuffer",
                    withCredentials: true,
                    headers: this.getHeaders(),
                })
                .subscribe(
                    (response) => resolve(response),
                    (err) => reject(err)
                );
        });
    }

    protected get(methodWtithLimits): Observable<any> {
        const option = { headers: this.getHeaders(), withCredentials: false };
        return this.http
            .get(this.toApiUrl(methodWtithLimits), option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    protected post(data, method = " "): Observable<any> {
        const option = { headers: this.getHeaders() };
        return this.http
            .post(this.toApiUrl(method), data, option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    protected postCookie(data, method = " "): Observable<any> {
        const option = { headers: this.getHeaders(), withCredentials: false };
        return this.http
            .post(this.toApiUrl(method), data, option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    protected postGlobal(data, method = " "): Observable<any> {
        const option = { headers: this.getHeaders(), withCredentials: false };
        return this.http
            .post(this.toApiUrlGlobal(method), data, option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    protected put(data, method): Observable<any> {
        const option = { headers: this.getHeaders(), withCredentials: true };
        return this.http
            .put(this.toApiUrl("/" + method), data, option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    protected patch(endpoint: string, data: any): Observable<any> {
        const options = { headers: this.getHeaders(), withCredentials: false };
        console.log("1234")
        return this.http
            .patch(this.toApiUrl(endpoint), data, options)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );

    }

    protected delete(id): Observable<any> {
        const option = { headers: this.getHeaders(), withCredentials: false };
        return this.http
            .delete(this.toApiUrl("/" + id), option)
            .pipe(
                map((res: HttpResponse<JSON>) => res || {}),
                catchError(this.errorHandler)
            );
    }

    // public abstract getHeaders(): HttpHeaders;
    private getHeaders(): HttpHeaders {
    	let headers: HttpHeaders = new HttpHeaders();
    	headers.set('Content-Type', 'application/json');
    	return headers;
    }

    private errorHandler(err: HttpErrorResponse) {
        // console.log('function side error')
        if (err.error instanceof ErrorEvent) {
            console.log("client side error --------------------------------------");
        } else {
            console.log("error ", err);
            if (err.error.error != null) {
                let error = err.error.error;
                if (error.code == 401) {
                    console.log("Session token expired");
                }
                return throwError(error);
                // return Observable.throw(error);
            }
            return throwError(err.error);
            // return Observable.throw(err.error);
        }
    }

}
